import { Component, Input, inject } from "@angular/core"
import { Dictionary } from "./filtering-search-component-base/filtering-search-types"
import { IconNamesEnum } from "ngx-bootstrap-icons"
import { InstrumentIDService } from "src/app/services/instrument-id-service"
import { Router } from "@angular/router"

@Component({
    template: '',
    standalone: true
})

export class InstrumentAndPlanHelper {
    private instrumentIDService = inject(InstrumentIDService)
    private router = inject(Router)

    @Input() public instrumentIDLookup: Dictionary<string> = {}
    @Input() public classesLookup: Dictionary<string> = {}
    @Input() public treatmentColumnVisibility: Dictionary<any> = {}
    @Input() expandAll = false

    @Input() set extraData(dict: Dictionary<any>) {
        for (const [key, value] of Object.entries(dict)) {
            switch (key) {
                case 'instrumentIDLookup':
                    this.instrumentIDLookup = value
                    break
                case 'classesLookup':
                    this.classesLookup = value
                    break
                case 'treatmentColumnVisibility':
                    this.treatmentColumnVisibility = value
                    break
            }
        }
    }

    public company = {}
    public iconNames = IconNamesEnum


    createInstrumentIDLookupLookup(capital_structures: any) {
        this.instrumentIDLookup = {}
        if (capital_structures !== null) {
            for (const structure of Object.values(capital_structures)) {
                if (Array.isArray(structure) && structure.length > 0) {
                    structure.forEach((element: any) => {
                        this.instrumentIDLookup[element.instrument_id] = element.instrument_name
                    })
                }
            }
        }
    }
    getNonEmptyColumns(arrayOfObjects: any[], result : string[] = [], columnsToReturn : string[] = []) : string[] {
        const exactMinMaxRegex = /(.*)(_min|_max|_exact)$/
        if (arrayOfObjects && arrayOfObjects.length > 0) {
            let columnLookup : Dictionary<boolean> = {}
            for (const row of arrayOfObjects) {
                for (let key of Object.keys(row)) {
                    const value = row[key]

                    const matches = key.match(exactMinMaxRegex)

                    if (matches) {
                        columnLookup[ matches[1] ] = true
                    } else if (typeof value === 'number') {
                        columnLookup[key] = true
                    } else if (typeof value === 'string' && !isNaN(Number(value)) && !isNaN(parseFloat(value))) {
                        columnLookup[key] = true
                    } else if (typeof value === 'string') {
                        columnLookup[key] = (columnLookup[key] ?? false) || value.trim().length > 0
                    } else if (typeof value === 'object') {
                        if (Array.isArray(value)) {
                            columnLookup[key] = columnLookup[key] || value.length > 0
                        } else {
                            columnLookup[key] = true
                        }
                    }
                }
            }
            for (const key in columnLookup) {
                if (columnLookup[key]) {
                    result.push(key)
                }
                if (columnsToReturn.length > 0) {
                    result = result.filter( (col) => columnsToReturn.indexOf(col) !== -1)
                }
            }
        }
        return result
    }
    createTreatmentGroups(planClasses: any[]) {
        planClasses.forEach(element => {
            this.classesLookup[element.class_id] = `#${element.class_number} ${element.class_name}`
            this.treatmentColumnVisibility[element.class_id] = {  }
            element.toggle_treatments.forEach((treatment: { groupedTreatments: any[]; count: number; treatments: any[]; }) => {
                treatment.groupedTreatments = []
                treatment.count = 0
                treatment.treatments.forEach((t) => {
                    treatment.groupedTreatments[t.option_number] = treatment.groupedTreatments[t.option_number] || []
                    treatment.groupedTreatments[t.option_number].push(t)
                    treatment.count ++

                    for (const [key, value] of Object.entries(t)) {
                        this.treatmentColumnVisibility[element.class_id][key] = this.treatmentColumnVisibility[element.class_id][key] || (value as string).length > 0
                    }

                })
                treatment.groupedTreatments = Object.values(treatment.groupedTreatments)
            })
        })
    }

    public openInstrument(event: Event, situationID: string, iid: string) {
        event.preventDefault()
        if (this.instrumentIDService.listener) {
            this.instrumentIDService.setIID(iid)
        } else {
            this.router.navigate( ['/situations', situationID], {
                state: {
                    iid
                }
            })

        }
    }
}